<template>
    <v-container fluid>
        <v-card>
            <div id="update-discount" class="py-3 px-3">
                <p class="font-weight-bold headline">Update Discount Qualification for {{ updateDiscount.opportunityId }}</p>
                <p class="title">This section enables you to only change the pricing qualification responses. As the submitter, your responses will be the attestation of these changes. If you need other edits to your submission, please email <a href="mailto:aws-oppreg@cloud.dxc.com">AWSOppreg Team</a></p>
                <div class="pricing-tier-overview-container">
                    <div class="my-2 px-2 py-1 black">
                        <label class="font-weight-bold white--text">Pricing Tiers Overview [<a href="#" @click="downloadGuide" >Download Oppreg Guide for more details</a>] </label>
                    </div>
                    <div class="px-2 py-2">
                        <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                        <ul>
                            <li><a href="#" @click="downloadGuide" ><u>Download Oppreg Guide</u></a> for discount details. Note the public sector SPP qualifications in the OppReg guide.</li>
                            <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                            <li>Private Pricing Agreement (PPA) – 21% discount for qualified workloads.</li>
                            <li>View the OppReg guide download for pricing tier details. </li>
                        </ul>
                    </div>
                </div>
                <v-layout
                    row
                    wrap
                >
                    <v-flex md12>
                    <div class="my-2 px-2 py-1 black">
                        <label class="font-weight-bold white--text">Pricing Qualification Version 2.0</label>
                    </div>
                    <div class="my-2">
                        <label class="font-weight-bold red--text">Select the ONE statement that applies to the AWS workload *</label>
                    </div>

                    <v-layout
                        column
                        >
                        <v-radio-group
                            light
                            class="pricing-tier-qualification px-3"
                            v-model="pricingTierQualification">
                            <v-radio
                                class="my-2 pricing-tier-radio"
                                value="1"
                                color="orange"
                            >
                                <span slot="label" class="ml-2 black--text">1. The solution is based primarily on DXC IP whereby the customer will not have access to the associated AWS services, infrastructure or operating systems managed by DXC.</span>
                            </v-radio>
                            <div v-if="pricingTierQualification == '1'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                                <label class="font-weight-bold black--text title">1. Based on your selection of #1, this workload qualifies for the PPA discount</label>
                            </div>
                            <v-radio
                                class="my-2 pricing-tier-radio"
                                value="2"
                                color="orange"
                            >
                                <span slot="label" class="ml-2 black--text">2. The customer requires direct access to the AWS Console, workloads, services, or logs. </span>
                            </v-radio>
                            <div v-if="pricingTierQualification == '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                                <label class="font-weight-bold black--text title">2. Based on your selection of #2, this workload qualifies for the SPP discount</label>
                            </div>
                        </v-radio-group>
                    </v-layout>
                    <div class="my-2 px-2 py-1 black">
                        <label class="font-weight-bold white--text">Attestation</label>
                    </div>
                    <v-layout row style="gap: 1rem">
                        <v-flex md6>
                            <v-text-field
                                v-model="attestedDate"
                                label="Attested Date"
                                readonly
                            />
                        </v-flex>
                        <v-flex md6>
                            <v-text-field
                                v-model="attestedByEmail"
                                label="Email *"
                                readonly
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout style="gap: 1rem">
                        <v-flex md6>
                        <v-text-field
                            v-validate="{ required: true }"
                            v-model.lazy="attestedByTitle"
                            :error-messages="errors.collect('attestedByTitle')"
                            data-vv-name="attestedByTitle"
                            data-vv-validate-on="blur"
                            label="Job Title *"
                        />
                        </v-flex>
                        <v-flex md6>
                        <v-text-field
                            v-validate="{ required: true }"
                            v-model.lazy="attestedByManager"
                            :error-messages="errors.collect('attestedByManager')"
                            data-vv-name="attestedByManager"
                            data-vv-validate-on="blur"
                            label="Manager *"
                        />
                        </v-flex>
                    </v-layout>
                    <div>
                        <p>Attestation and the response content is required for contractual compliancy. This attestation is subject to audit. Inaccurate responses could change the pricing tier. If you are unsure of responses throughout this application for registration, please defer to your manager to assist. </p>
                    </div>
                    
                    <div v-if="pricingTierQualification == '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                        <p class="font-weight-bold black--text title">Reminder, Please download the Oppreg Guide. SPP has dependencies in order to realise the full SPP discount.</p>
                    </div>
                    <div class="text-md-center">
                        <v-btn
                            :loading="updateDiscount.saving"
                            :disabled="updateDiscount.saving || notReadytoSubmit"
                            class="auto"
                            color="success"
                            @click="onUpdateDiscount">
                            Submit Updated Pricing Qualification
                        </v-btn>
                    </div>
                    </v-flex>
                </v-layout>
            </div>
        </v-card>
    </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            attestedDateMenu: false,
            pricingTierQualification: '',
            newWorkloadType: '',
            attestedDate: window.moment().format('YYYY-MM-DD'),
            attestedByEmail: vm.$store.state.currentUser.email,
            attestedByManager: '',
            attestedByTitle: ''
        }
    },
    computed: {
        ...mapState('user/requestOppreg', ['workloadForm','updateDiscount']),
        notReadytoSubmit() {
            if (!this.pricingTierQualification || !this.attestedDate || !this.attestedByEmail || !this.attestedByTitle || !this.attestedByManager) {
                return true
            }
            return false
        }
    },
    methods: {
        ...mapActions({
            submitDiscount: 'user/requestOppreg/submitDiscount'
        }),
        downloadGuide () {
            window.open(window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf', '_blank').focus();
        },
        onUpdateDiscount() {
            if (this.pricingTierQualification == 1) {
                this.newWorkloadType = 'PPA'
            } else if (this.pricingTierQualification == 2) {
                this.newWorkloadType = 'SPP'
            }
            // pass the new updated value
            let newChanges = {
                Workload_type: this.newWorkloadType,
                Attested_By_Date_2: this.attestedDate,
                Attested_By_Email_2: this.attestedByEmail,
                Attested_By_Manager_2: this.attestedByManager,
                Attested_By_Title_2: this.attestedByTitle,
                Pricing_Tier_Qualification_2: this.pricingTierQualification,
                Workload_Type_Date_Change: this.attestedDate
            }
            this.submitDiscount(newChanges)
        }
    },
}
</script>
<style lang="scss" scoped>

.pricing-tier-radio /deep/ label {
    color: rgba(0,0,0,.87) !important;
}

#update-discount {
    .pricing-tier-overview-container > div > p {
      border-bottom: 1px solid #000;
      font-size: 16px !important;
      color: #000;
    }

    .pricing-tier-qualification {
        font-weight: bold;
        .pricing-tier-radio {
            input {
                margin: 30px;
            }
        }
    }
}
</style>